import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';

import 'assets/third-party/landing.css';

const LandingLayout = () => {
  return (
    <>
      <Header />
      <Outlet />
      <Footer />
    </>
  );
};
export default LandingLayout;
